import React, { useState, memo, useEffect } from "react";
import {
	Row, Col,
	Card, CardBody,
	Input, Button,
	Progress
} from "reactstrap";
import Sound from 'react-sound';
import MicRecorder from 'mic-recorder-to-mp3';
import { base, s3base } from "api.js";
import HeadsetCheck from "components/FullTest/ResourceChecking/HeadsetCheck";
import MicrophoneCheck from "components/FullTest/ResourceChecking/MicrophoneCheck";
import KeyboardCheck from "components/FullTest/ResourceChecking/KeyboardCheck";
import TestIntroduction from "components/FullTest/ResourceChecking/TestIntroduction";
import SpeakingInstructions from "components/FullTest/ResourceChecking/SpeakingInstructions";

export default function ResourceCheck(props) {

	const [checkpoint, setCheckPoint] = useState(1);
	const [nextFlag, setNextFlag] = useState(false);

	useEffect(() => {
		if (checkpoint > 5) {
			props.setStep(prev => (prev + 1));
		}
	}, [checkpoint]);

	const nextButton = (e) => {
		setCheckPoint(prev => (prev + 1));
		setNextFlag(false);
	};

	return (
		<div className="content questionsArea deviceTestPage">
			<Row>
				<Col xs={12}>
					<Card>
						<CardBody>
							{checkpoint === 1 &&
								<HeadsetCheck
									setNextFlag={setNextFlag}
								/>
							}

							{checkpoint === 2 &&
								<MicrophoneCheck
									setNextFlag={setNextFlag}
								/>
							}

							{checkpoint === 3 &&
								<KeyboardCheck
									setNextFlag={setNextFlag}
								/>
							}

							{checkpoint === 4 &&
								<TestIntroduction
									setNextFlag={setNextFlag}
								/>
							}

							{checkpoint === 5 &&
								<SpeakingInstructions
									setNextFlag={setNextFlag}
								/>
							}
						</CardBody>
					</Card>
				</Col>

				<Col xs={12}>
					<div className="bottomBtns">
						<Row>
							<Col xs={9}>
								
							</Col>
							<Col xs={3}>
								<Button
									color="primary"
									disabled={!nextFlag}
									onClick={nextButton}
									size="xs"
								>NEXT</Button>
							</Col>
						</Row>
					</div>
				</Col>
			</Row>
		</div>
	);
}